// extracted by mini-css-extract-plugin
export default {"main":"Auth_main__V9loQ","button":"Auth_button__wQt5L","link":"Auth_link__arFAN","buttonInActive":"Auth_buttonInActive__JKG6e","info":"Auth_info__GQXs4"};